import React from 'react';

const AnnotationDetails = ({data}) => {
    return (
        <>
            <p className={`text-[16px] font-bold  p-2 bg-gray-300 mb-0`}>
                Anotação
            </p>
            <div className={"p-2 max-h-[calc(100vh-174px)] overflow-auto"}>
                {data.value}
            </div>
        </>
    )
};

export default AnnotationDetails;